/**
 * The locale → content map.
 *
 * English is absent by design: it is the base in `content/en.ts`, not a
 * translation of itself, and `dictionaryFor('en')` returns it untouched rather
 * than merging it with a copy of itself.
 *
 * A locale listed in `src/i18n/locales.ts` with no entry here is not an error —
 * it renders wholly in English and reports 0% coverage, which is the honest
 * state of a language somebody has announced and not yet written.
 */
import type { Translation } from '@/i18n/dictionary'
import { de } from './de'
import { es } from './es'
import { fr } from './fr'
import { pt } from './pt'
import { tr } from './tr'

export const translations: Record<string, Translation | undefined> = { de, es, fr, pt, tr }
